import axios from 'axios';
import createSignedRequest from './createSignedRequest';

const { apiURL } = require('./apiURL');

const Types = {
  RATES: 'INDEXATION_RATES',
  EVENTS: 'INDEXATION_EVENTS',
  LOADING: 'INDEXATION_LOADING',
  ERROR: 'INDEXATION_ERROR',
  CLEAR: 'INDEXATION_CLEAR',
};

const getIndexationRates = (source) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.currentOrganisation) return null;

    const q = source ? `?source=${encodeURIComponent(source)}` : '';
    dispatch({ type: Types.LOADING, key: 'rates', value: true });
    dispatch({ type: Types.ERROR, value: null });
    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + '/my/indexation/rates' + q, null, {
          Organisation: String(state.currentOrganisation),
        })
      );
      const data = response.data;
      dispatch({ type: Types.RATES, payload: { source: data?.source, rates: data?.rates || [] } });
      return data;
    } catch (e) {
      const msg = e?.response?.data?.message || e.message;
      dispatch({ type: Types.ERROR, value: msg });
      return null;
    } finally {
      dispatch({ type: Types.LOADING, key: 'rates', value: false });
    }
  };
};

const upsertIndexationRate = (source, periodEndIso, body) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.currentOrganisation) return null;

    const path = `/my/indexation/rates/${encodeURIComponent(source)}/${encodeURIComponent(periodEndIso)}`;
    try {
      await axios(
        await createSignedRequest('PUT', apiURL + path, JSON.stringify(body), {
          Organisation: String(state.currentOrganisation),
        })
      );
      await dispatch(getIndexationRates(source));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data || e.message };
    }
  };
};

const deleteIndexationRate = (source, periodEndIso) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.currentOrganisation) return null;

    const path = `/my/indexation/rates/${encodeURIComponent(source)}/${encodeURIComponent(periodEndIso)}`;
    try {
      await axios(
        await createSignedRequest('DELETE', apiURL + path, null, { Organisation: String(state.currentOrganisation) })
      );
      await dispatch(getIndexationRates(source));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data || e.message, code: e?.response?.data?.code };
    }
  };
};

const getContractIndexation = (contractId) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.currentOrganisation) return null;

    dispatch({ type: Types.LOADING, key: 'events', value: true });
    try {
      const response = await axios(
        await createSignedRequest(
          'GET',
          apiURL + '/my/agreements/' + encodeURIComponent(contractId) + '/indexation',
          null,
          { Organisation: String(state.currentOrganisation) }
        )
      );
      const data = response.data;
      dispatch({ type: Types.EVENTS, payload: { contractId, data } });
      return data;
    } catch (e) {
      dispatch({ type: Types.ERROR, value: e?.response?.data?.message || e.message });
      return null;
    } finally {
      dispatch({ type: Types.LOADING, key: 'events', value: false });
    }
  };
};

const patchContractIndexationEvent = (contractId, anniversaryDateIso, body) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.currentOrganisation) return null;

    const path =
      '/my/agreements/' +
      encodeURIComponent(contractId) +
      '/indexation/' +
      encodeURIComponent(anniversaryDateIso);
    try {
      await axios(
        await createSignedRequest('PATCH', apiURL + path, JSON.stringify(body), {
          Organisation: String(state.currentOrganisation),
        })
      );
      await dispatch(getContractIndexation(contractId));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data || e.message, code: e?.response?.data?.code };
    }
  };
};

const clearIndexation = () => ({ type: Types.CLEAR });

const Actions = {
  getIndexationRates,
  upsertIndexationRate,
  deleteIndexationRate,
  getContractIndexation,
  patchContractIndexationEvent,
  clearIndexation,
};

export { Actions, Types };
